

























import { Component, Vue, Watch } from 'vue-property-decorator';
import ToolImgColor from '@/views/tool/imgcolor/Index.vue';

@Component({
  components: { ToolImgColor },
})
export default class ToolImgColorPicker extends Vue {
  public visible = false;
  public maxHeight = 0;

  public get color() {
    return this.visible ? 'primary' : '';
  }

  public onClose() {
    this.visible = false;
  }

  @Watch('visible')
  public menuChange() {
    this.maxHeight = document.documentElement.clientHeight - 96;
  }
}
